module.exports = __webpack_public_path__ + "img/lang_docker.ff73f4ac.svg";